module.exports = __webpack_public_path__ + "img/image-16.c4ebe80a.webp";